




















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "DeleteBtn",
  props: {
    ml: {
      type: Boolean,
      default: false,
    },
    mr: {
      type: Boolean,
      default: false,
    },
  },
});
